import { ORDER_STATUS } from '@/modules/order/constants/order-status.constant'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../modules/shared/components/ui/tooltip'
import { Icon } from './ui/icon'

type OrderFormStatusBadgeComponentProps = {
  status: string
  sigla: string
}

export function OrderStatusBadgeComponent({
  status,
  sigla,
}: OrderFormStatusBadgeComponentProps) {
  const orderStatus = ORDER_STATUS[sigla]
  const label = orderStatus?.label ?? status

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger
          type="button"
          aria-label={`${sigla} - ${label}`}
          className="cursor-help rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <div className=" flex flex-row items-center space-x-1">
            {orderStatus && (
              <Icon
                iconColor={orderStatus.color}
                IconChildren={orderStatus.icon}
              />
            )}
            <p>{sigla}</p>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
